
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tab/[...slug]",
      function () {
        return require("private-next-pages/tab/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tab/[...slug]"])
      });
    }
  